import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { clients, getClientById, getChantiersByClient } from '../utils/mockData';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ChantierCard } from '../components/ChantierCard';
import { ArrowLeft, Star, Phone, Mail, MapPin, FileText, Briefcase, AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function ClientDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const client = getClientById(id!);
  if (!client) {
    return <div className="p-8 text-center" data-id="element-407">
        <p className="text-gray-500" data-id="element-408">Client non trouvé</p>
      </div>;
  }
  const chantiers = getChantiersByClient(client.id);
  const activeChantiers = chantiers.filter(ch => ch.status === 'en_cours');
  const completedChantiers = chantiers.filter(ch => ch.status === 'termine');
  const blockedChantiers = chantiers.filter(ch => ch.status === 'bloque');
  return <div className="min-h-screen bg-gray-50 pb-20 md:pb-6" data-id="element-409">
      <div className="page-container section-spacing" data-id="element-410">
        <Button variant="ghost" size="sm" className="pl-0 hover:bg-transparent hover:text-[#1DBAB4]" onClick={() => navigate(-1)} leftIcon={<ArrowLeft size={16} data-id="element-412" />} data-id="element-411">
          Retour
        </Button>

        {/* Client Header */}
        <Card hover={false} className="p-6" data-id="element-413">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-4" data-id="element-414">
            <div className="flex-1" data-id="element-415">
              <div className="flex items-center gap-3 mb-4" data-id="element-416">
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-417">
                  {client.raisonSociale}
                </h1>
                {client.isStrategicAccount && <div className="flex items-center gap-1.5 px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-sm font-medium" data-id="element-418">
                    <Star size={14} className="fill-current" data-id="element-419" />
                    Compte stratégique
                  </div>}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-420">
                <div className="space-y-3" data-id="element-421">
                  <div data-id="element-422">
                    <p className="text-xs font-medium text-gray-500 uppercase mb-1" data-id="element-423">
                      Contact principal
                    </p>
                    <p className="text-gray-900 font-medium" data-id="element-424">
                      {client.contactName}
                    </p>
                  </div>

                  <div className="flex items-center gap-2 text-gray-600" data-id="element-425">
                    <Phone size={16} className="text-gray-400" data-id="element-426" />
                    <span data-id="element-427">{client.phone}</span>
                  </div>

                  {client.email && <div className="flex items-center gap-2 text-gray-600" data-id="element-428">
                      <Mail size={16} className="text-gray-400" data-id="element-429" />
                      <span data-id="element-430">{client.email}</span>
                    </div>}
                </div>

                <div className="space-y-3" data-id="element-431">
                  <div data-id="element-432">
                    <p className="text-xs font-medium text-gray-500 uppercase mb-1" data-id="element-433">
                      Adresse de facturation
                    </p>
                    <div className="flex items-start gap-2 text-gray-600" data-id="element-434">
                      <MapPin size={16} className="text-gray-400 mt-0.5" data-id="element-435" />
                      <span data-id="element-436">{client.billingAddress}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sites */}
              {client.sites.length > 0 && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-437">
                  <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-438">
                    Sites ({client.sites.length})
                  </p>
                  <div className="flex flex-wrap gap-2" data-id="element-439">
                    {client.sites.map((site, index) => <span key={index} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm" data-id="element-440">
                        {site}
                      </span>)}
                  </div>
                </div>}

              {/* Notes */}
              {client.notes && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-441">
                  <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-442">
                    Notes internes
                  </p>
                  <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg" data-id="element-443">
                    <FileText size={16} className="text-blue-600 mt-0.5" data-id="element-444" />
                    <p className="text-sm text-gray-700" data-id="element-445">{client.notes}</p>
                  </div>
                </div>}
            </div>
          </div>
        </Card>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-446">
          <Card hover={false} className="p-4" data-id="element-447">
            <div className="flex items-center gap-3" data-id="element-448">
              <div className="p-3 bg-blue-50 rounded-lg" data-id="element-449">
                <Briefcase className="w-6 h-6 text-[#1E2A3A]" data-id="element-450" />
              </div>
              <div data-id="element-451">
                <p className="text-2xl font-bold text-gray-900" data-id="element-452">
                  {chantiers.length}
                </p>
                <p className="text-sm text-gray-500" data-id="element-453">Total</p>
              </div>
            </div>
          </Card>

          <Card hover={false} className="p-4" data-id="element-454">
            <div className="flex items-center gap-3" data-id="element-455">
              <div className="p-3 bg-teal-50 rounded-lg" data-id="element-456">
                <Briefcase className="w-6 h-6 text-[#1DBAB4]" data-id="element-457" />
              </div>
              <div data-id="element-458">
                <p className="text-2xl font-bold text-gray-900" data-id="element-459">
                  {activeChantiers.length}
                </p>
                <p className="text-sm text-gray-500" data-id="element-460">En cours</p>
              </div>
            </div>
          </Card>

          <Card hover={false} className="p-4" data-id="element-461">
            <div className="flex items-center gap-3" data-id="element-462">
              <div className="p-3 bg-green-50 rounded-lg" data-id="element-463">
                <Briefcase className="w-6 h-6 text-green-600" data-id="element-464" />
              </div>
              <div data-id="element-465">
                <p className="text-2xl font-bold text-gray-900" data-id="element-466">
                  {completedChantiers.length}
                </p>
                <p className="text-sm text-gray-500" data-id="element-467">Terminés</p>
              </div>
            </div>
          </Card>

          <Card hover={false} className="p-4" data-id="element-468">
            <div className="flex items-center gap-3" data-id="element-469">
              <div className="p-3 bg-red-50 rounded-lg" data-id="element-470">
                <AlertCircle className="w-6 h-6 text-[#E85D4A]" data-id="element-471" />
              </div>
              <div data-id="element-472">
                <p className="text-2xl font-bold text-gray-900" data-id="element-473">
                  {blockedChantiers.length}
                </p>
                <p className="text-sm text-gray-500" data-id="element-474">Bloqués</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Chantiers List */}
        <div data-id="element-475">
          <div className="flex items-center justify-between mb-6" data-id="element-476">
            <h2 className="heading-md" data-id="element-477">Chantiers ({chantiers.length})</h2>
          </div>

          {chantiers.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-478">
              {chantiers.map((chantier, index) => <motion.div key={chantier.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.05
          }} data-id="element-479">
                  <ChantierCard chantier={chantier} data-id="element-480" />
                </motion.div>)}
            </div> : <Card hover={false} className="p-12 text-center" data-id="element-481">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-482">
                <Briefcase className="text-gray-400" size={32} data-id="element-483" />
              </div>
              <h3 className="text-lg font-medium text-gray-900" data-id="element-484">
                Aucun chantier
              </h3>
              <p className="text-gray-500 mt-1" data-id="element-485">
                Aucun chantier pour ce client.
              </p>
            </Card>}
        </div>
      </div>
    </div>;
}